// extracted by mini-css-extract-plugin
export default {"root":"ResultsListEmpty_root__G_8HH","title":"ResultsListEmpty_title__M2dDF","copy":"ResultsListEmpty_copy__AYrFG"};